<template>
  <VisaForm country="schengen" :products>
    <template #visa_select="{ form }">
      <BasketFields :form :products />
      <EntryFields v-model="form.entry" />
      <TermsCheckbox v-model="form.termsAgreed" />
    </template>

    <template #details="{ form }">
      <ClientFields v-model="form.client" />
      <StayAddress v-model="form.stayAddress" />
      <PassportDetailsNotes />
      <LazyApplicantInfo
        v-for="(applicant, i) in form.applicants"
        :applicant="applicant"
        :index="i"
      >
        <template #passport>
          <PassportFields v-model="applicant.passport" />
        </template>
        <template #personal>
          <CityOfBirth v-model="applicant.cityOfBirth" />
          <AddressFields v-model="applicant.address" />
          <OccupationFields v-model="applicant.occupation" has-phone has-address />
          <MaritalStatusSelect v-model="applicant.maritalStatus" />
        </template>
      </LazyApplicantInfo>
    </template>

    <template #review />
    <template #payment />
  </VisaForm>
</template>

<script setup lang="ts">
import type { Product } from '~/types';

defineProps<{
  products: Product[];
}>();
</script>